import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ColDef, GridApi, GridReadyEvent,RowClassRules  } from 'ag-grid-community';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { MerchantService } from '../merchant.service';
import * as moment from 'moment';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';


export class ResellerCommissionRequest {
  userId: any;
  userType: string;
  // fee: any[];
  // resellerCommission: any;
  entityId: any;
  feeType: any;
  commission: number | null;
  specialReferralCommissionAmount: any;
  partnerId: any;
  isSpecialReferralReseller: any;
  fromAmount: any;
  toAmount: any;
  commissionType: any;
}

@Component({
  selector: 'app-merchant-configuration',
  templateUrl: './merchant-configuration.component.html',
  styleUrls: ['./merchant-configuration.component.scss']
})
export class MerchantConfigurationComponent implements OnInit {

  permissions :any;
  merchantId : any;
  pageSize: number = 10;
  private gridApiCommission: GridApi;
  private gridApiFee: GridApi;
  maximumCommissionAmount :number = 1000000;
  maximumFeeAmount :number = 100;
  settlementCycleList: any[] = [{'name':'Hourly','value':'Hourly'},{'name':'Daily','value':'Daily'}];
  commissionList : any[] = [];
  resellerCommissionList : any;
  feeList : any[] = [];
  settlementCycle : any = null;
  settlementEnable : boolean = true;
  commissionEnable : boolean = true;
  feeEnable : boolean = true;
  dataEnable : boolean = true;
  emptyList : any[];
  saveData : any;
  saveResellerData : any;
  
  // Max value edit states
  editingCommissionMaxValue: boolean = false;
  editingFeeMaxValue: boolean = false;
  tempCommissionMaxValue: number = 1000000;
  tempFeeMaxValue: number = 100;
  public defaultColDef: ColDef = {
    flex: 1,
    resizable: true,
  };

  //Reseller Commission 

  saveConstantConfigurationData: any;
  resellerCommissionEnable: boolean = true;
  resellerCommissionRequest: ResellerCommissionRequest;

  showResellerCommissionSection = false;

  resellerMerchantCommissionTempList: any[] = [];
  resellerCommission: any;
  resellerName: string = '';
  isSpecialPartner: boolean = false;
  commissionModel: string | null = null;
  commissionPercentage: number = 0;
  effectiveDate: string | null = null;
  today: string = '';

  commissionModelList = [
    { label: 'Fixed', value: 'Fixed' },
    { label: 'Variable', value: 'Variable' }
  ];

  constantList = {
    fromAmount: 0.0,
    toAmount: 0.15
  };

  constantFromAmount: any;
  constantToAmount: any;
  
  public columnDefsCommission: ColDef[] = [
      {
        field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable:false
      },
      {
        field: 'toAmount',lockVisible:true,  headerName: 'To Amount',editable:false, resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
          if (Number(params.newValue) <= (Number(this.maximumCommissionAmount) - 1)) {
            const nextRowVal = this.gridApiCommission.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
            const rowNode = this.gridApiCommission.getRowNode((params.node.rowIndex + 1).toString());
            if (rowNode) {
              this.commissionList[params.node.rowIndex + 1].fromAmount = 0.01 + Number(params.newValue)
              const newData = { ...rowNode.data, fromAmount: 0.01 + Number(params.newValue) };
              rowNode.setData(newData);
              this.gridApiCommission.refreshCells({ rowNodes: [rowNode], force: true });
            }
          }
        }
      },
      {
        field: 'commissionType',lockVisible:true,  headerName: 'Commission Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
          options: [
            { value: 'FLAT', label: 'FLAT' },
            { value: 'PERCENTAGE', label: 'PERCENTAGE' },
          ]
        }
      },
      { field: 'commission',lockVisible:true,  headerName: 'Commission', cellRenderer: InputCellRenderer, onCellValueChanged: (params: any) => {
        if (params.data.commissionType == "PERCENTAGE") {
          if(parseFloat(params.newValue) > 100){
            this.alertService.toastWarringMessageAlertWithMessage("Merchant Fee cannot be greater than 100 Percentage");
            const rowNode = this.gridApiCommission.getRowNode((params.node.rowIndex).toString());
            if(rowNode){
              this.commissionList[params.node.rowIndex].commission = 0;
              this.gridApiCommission.setRowData(this.commissionList);
            }
          }
        }else if(params.data.commissionType == "FLAT"){
          console.log(params.data.toAmount);
          if(parseFloat(params.newValue) > parseFloat(params.data.toAmount)){
            this.alertService.toastWarringMessageAlertWithMessage("Merchant Fee cannot be greater than 'TO AMOUNT'");
            const rowNode = this.gridApiCommission.getRowNode((params.node.rowIndex).toString());
            if(rowNode){
              this.commissionList[params.node.rowIndex].commission = 0;
              this.gridApiCommission.setRowData(this.commissionList);
            }
          }
        } 
      }},
      { field: 'id', headerName: 'ID', hide: true },
  
    ];

    public columnDefsFee: ColDef[] = [
      {
        field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable:false
      },
      {
        field: 'toAmount',lockVisible:true,  headerName: 'To Amount',editable:false, resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
          if (Number(params.newValue) <= (Number(this.maximumFeeAmount) - 1)) {
            const nextRowVal = this.gridApiFee.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
            const rowNode = this.gridApiFee.getRowNode((params.node.rowIndex + 1).toString());
            if (rowNode) {
              this.feeList[params.node.rowIndex + 1].fromAmount = 0.01 + Number(params.newValue)
              const newData = { ...rowNode.data, fromAmount: 0.01 + Number(params.newValue) };
              rowNode.setData(newData);
              this.gridApiFee.refreshCells({ rowNodes: [rowNode], force: true });
            }
          }
        }
      },
      {
        field: 'commissionType',lockVisible:true,  headerName: 'Commission Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
          options: [
            { value: 'FLAT', label: 'FLAT' },
            { value: 'PERCENTAGE', label: 'PERCENTAGE' },
          ]
        }
      },
      { field: 'commission',lockVisible:true,  headerName: 'Commission', cellRenderer: InputCellRenderer, onCellValueChanged: (params: any) => {
        if (params.data.commissionType == "PERCENTAGE") {
          if(parseFloat(params.newValue) > 100){
            this.alertService.toastWarringMessageAlertWithMessage("Addition Fee cannot be greater than 100 Percentage");
            const rowNode = this.gridApiFee.getRowNode((params.node.rowIndex).toString());
            if(rowNode){
              this.feeList[params.node.rowIndex].commission = 0;
              this.gridApiFee.setRowData(this.feeList);
            }
          }
        }else if(params.data.commissionType == "FLAT"){
          console.log(params.data.toAmount);
          if(parseFloat(params.newValue) > parseFloat(params.data.toAmount)){
            this.alertService.toastWarringMessageAlertWithMessage("Addition Fee cannot be greater than 'TO AMOUNT'");
            const rowNode = this.gridApiFee.getRowNode((params.node.rowIndex).toString());
            if(rowNode){
              this.feeList[params.node.rowIndex].commission = 0;
              this.gridApiFee.setRowData(this.feeList);
            }
          }
        } 
      }},
      { field: 'id', headerName: 'ID', hide: true },
  
    ];

  public columnCommission: ColDef[] = [...this.columnDefsCommission];
  public columnFee: ColDef[] = [...this.columnDefsFee];

  constructor(private router: Router,private menuService: MenusService,private location:Location,private merchantService: MerchantService,private alertService : AlertService, private route: ActivatedRoute) { }

  async ngOnInit(){
    this.commissionList = [];
    this.feeList = [];
    this.merchantId = this.route.snapshot.queryParamMap.get("mid");
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
    
    //for reseller effective date 
    const now = new Date();
    this.today = now.toISOString().split('T')[0];

    this.getResellerMerchantDetails();

    //fetch constant configuration response and get fromAmount and toAmount
    this.merchantService.getConstantConfiguration("Variable").subscribe((response: any) => {
      console.log("constant config details : {} ", response);
      this.saveConstantConfigurationData = JSON.parse(JSON.stringify(response.response.data));
      console.log("constant config save data  : {}", this.saveConstantConfigurationData);
      this.constantFromAmount = Number(this.saveConstantConfigurationData.fromAmount);
      this.constantToAmount = Number(this.saveConstantConfigurationData.toAmount);

    });

  }

  /* Allow only letters & spaces for Reseller Name */
  allowOnlyLetters(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which || event.keyCode);
    if (!/^[a-zA-Z ]$/.test(char)) {
      event.preventDefault();
    }
  }

  /* Handle commission model change */
  // onCommissionModelChange(model: string) {
  //   if (model === 'Fixed') {
  //     this.commissionPercentage = 0; // locked
  //   }
  // }

  allowOnlyNumbersAndDot(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which || event.keyCode);

    // Allow digits and decimal point
    if (!/^[0-9.]$/.test(char)) {
      event.preventDefault();
    }

    // Prevent more than one decimal point
    if (char === '.' && (event.target as HTMLInputElement).value.includes('.')) {
      event.preventDefault();
    }
  }


  saveCommission(type : any){
    console.log(type)

    if(type == "Save"){

      // in BE its CommissionListDTO 
       this.setResellerCommissionRequest();

      if(this.settlementCycle == null || this.settlementCycle == undefined){
        this.alertService.toastWarringMessageAlertWithMessage("Please Select Settlement Cycle");
        return;
      }
      if(this.commissionList.length == 0 || this.commissionList == undefined || this.commissionList == null){
        this.alertService.toastWarringMessageAlertWithMessage("Please Set Merchant Commission");
        return;
      }
      if(this.feeList.length == 0 || this.feeList == undefined || this.feeList == null){
        this.alertService.toastWarringMessageAlertWithMessage("Please Set Addition Fee");
        return;
      }
      this.commissionList.map((_:any)=>{
        delete _.isAmountDisabled;
      })

      this.feeList.map((_:any)=>{
        delete _.isAmountDisabled;
      })

      let request = {
        "userId" : this.merchantId,
        "userType" : "MERCHANT",
        "settlementCycle" : this.settlementCycle,
        "commission" : this.commissionList,
        "fee" : this.feeList,
        "resellerCommission":this.resellerCommissionRequest
        
      }
      console.log("commissionPercentage is ::{}" ,this.commissionPercentage);
      console.log(request);
      console.log(JSON.stringify(request))

      this.merchantService.saveConfiguration(request).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('Merchant Configuration Saved Successfully','','success');
          this.getConfirguration();
          this.getResellerMerchantDetails();
          this.disableAll();
        }else{
          Swal.fire(response.response.message,'','error');
        }
      })
    }else{

      // UPDATE 

      this.emptyList = [];
      let request = {
        "userId" : this.merchantId,
        "userType" : "MERCHANT",
        "settlementCycle" : null,
        "commission" : this.emptyList,
        "fee" : this.emptyList,
        "resellerCommission": this.resellerCommissionRequest
      }
  
      this.commissionList.map((_:any)=>{
        delete _.isAmountDisabled;
      })

      this.feeList.map((_:any)=>{
        delete _.isAmountDisabled;
      })

      if(!this.settlementEnable){
        if(this.settlementCycle == null || this.settlementCycle == undefined){
          this.alertService.toastWarringMessageAlertWithMessage("Please Select Settlement Cycle");
          return;
        }
        request.settlementCycle = this.settlementCycle;
      }

      if(!this.commissionEnable){
        if(this.commissionList.length == 0 || this.commissionList == undefined || this.commissionList == null){
          this.alertService.toastWarringMessageAlertWithMessage("Please Set Merchant Commission");
          return;
        }
        request.commission = this.commissionList;
      }

      if(!this.feeEnable){
        if(this.feeList.length == 0 || this.feeList == undefined || this.feeList == null){
        this.alertService.toastWarringMessageAlertWithMessage("Please Set Addition Fee");
        return;
      }
      
      request.fee = this.feeList;
      }

      if (!this.resellerCommissionEnable) {

        if (this.commissionPercentage == 0 || this.commissionPercentage == undefined || this.commissionPercentage == null) {
          this.alertService.toastWarringMessageAlertWithMessage("Please Set Reseller Commission ");
          return;
        }
        console.log(this.commissionPercentage);
        console.log(this.constantToAmount);
        console.log(this.constantFromAmount);
        if (this.commissionPercentage > parseFloat(this.constantToAmount) ||
          this.commissionPercentage < parseFloat(this.constantFromAmount)) {

          this.alertService.toastWarringMessageAlertWithMessage("Reseller Commission cannot be less than " +
            this.constantFromAmount + " and greater than " + this.constantToAmount);
          return;
        }
        this.setResellerCommissionRequest();
        request.resellerCommission = this.resellerCommissionRequest;

      }

      console.log(request);
      console.log(JSON.stringify(request))
      if(request.settlementCycle == null && request.fee.length == 0 && request.commission.length == 0 && request.resellerCommission == null ){
        this.alertService.toastWarringMessageAlertWithMessage("No changes to update");
        return;
      }
      this.merchantService.updateConfiguration(request).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('Merchant Configuration Updated Successfully','','success');
          this.getConfirguration();
          this.getResellerMerchantDetails();
          this.disableAll();
        }else{
          Swal.fire(response.response.message,'','error');
        }
      })
    }
  }


  private setResellerCommissionRequest() {
    
    this.resellerCommissionRequest = new ResellerCommissionRequest();
    if(this.resellerMerchantCommissionTempList.length>0){
      this.resellerCommissionRequest.feeType=this.resellerMerchantCommissionTempList[0].feeType,
      this.resellerCommissionRequest.specialReferralCommissionAmount=this.resellerMerchantCommissionTempList[0].specialReferralCommissionAmount,
      this.resellerCommissionRequest.isSpecialReferralReseller=this.resellerMerchantCommissionTempList[0].specialReferralReseller,
      this.resellerCommissionRequest.fromAmount=this.resellerMerchantCommissionTempList[0].fromAmount,
      this.resellerCommissionRequest.toAmount=this.resellerMerchantCommissionTempList[0].toAmount,
      this.resellerCommissionRequest.commissionType=this.resellerMerchantCommissionTempList[0].commissionType
      }
      this.resellerCommissionRequest.userId=this.merchantId,
      this.resellerCommissionRequest.userType="MERCHANT",
      // this.resellerCommissionRequest.fee=this.feeList,
      // this.resellerCommissionRequest.resellerCommission=this.saveResellerData.resellerCommission,
      this.resellerCommissionRequest.entityId=this.merchantId,
      this.resellerCommissionRequest.commission=this.commissionPercentage
      // this.resellerCommissionRequest.partnerId=this.saveResellerData.userId
   
  }

  getResellerMerchantDetails(){
    this.merchantService.getResellerMerchantDetails(this.merchantId).subscribe((response:any)=>{
    console.log(response)
      this.saveResellerData = JSON.parse(JSON.stringify(response.response.data));
      console.log(response.response.data.commission)
      this.resellerMerchantCommissionTempList = response.response.data.commission;
       console.log(this.resellerMerchantCommissionTempList)

      //check if reseller commission is null or undefined
      if (this.resellerMerchantCommissionTempList.length == 0 ) {
        console.log("Data not present for reseller")
        this.showResellerCommissionSection = true;
      }
      else {
        this.showResellerCommissionSection = true;
        console.log("Data present for reseller")
          this.resellerName = this.saveResellerData.entityName;
          this.commissionModel = this.resellerMerchantCommissionTempList[0].feeType;
          if(this.commissionModel === 'Fixed'){
            this.commissionPercentage = this.resellerMerchantCommissionTempList[0].commission;
          }
          {
          const specialReferralReseller = this.resellerMerchantCommissionTempList?.[0]?.isSpecialReferralReseller;
          this.isSpecialPartner = typeof specialReferralReseller === 'string'
            ? specialReferralReseller.toLowerCase() === 'yes'
            : !!specialReferralReseller;
        }
      }
  
      this.getConfirguration();
    })
  }

 
   getConfirguration(){
    this.merchantService.getConfiguration(this.merchantId).subscribe((response:any)=>{
    console.log(response)
      this.saveData = JSON.parse(JSON.stringify(response.response.data));
      this.settlementCycle = response.response.data.settlementCycle;
      this.feeList = response.response.data.fee;
      this.commissionList = response.response.data.commission;
      this.resellerCommissionList=response.response.data.resellerCommission;

      console.log(this.resellerCommissionList)
      if (this.resellerCommissionList != null || this.resellerCommissionList != undefined) {
        console.log("Data present for Merchant")
        console.log(this.resellerCommissionList.commission)
        // this.commissionPercentage = Number(
        //   this.resellerCommissionList.commission ?? 0
        // );
        console.log("commissionModel is 2{}", this.commissionModel)
        if(this.commissionModel === 'Variable'){
          console.log("Data present for Variable type")
            this.commissionPercentage = Number(
           this.resellerCommissionList.commission ?? 0
         );;
          }
      }
      else {
        console.log("Data not present for Merchant")
        this.commissionPercentage = Number(
          this.resellerMerchantCommissionTempList?.[0]?.commission ?? 0
        );
      }
      
      // Set max values from API response if available
      if (this.commissionList.length > 0) {
        const maxCommissionAmount = Math.max(...this.commissionList.map((item: any) => item.toAmount));
        this.maximumCommissionAmount = maxCommissionAmount > 0 ? maxCommissionAmount : 1000000;
        this.tempCommissionMaxValue = this.maximumCommissionAmount;
      }
      
      if (this.feeList.length > 0) {
        const maxFeeAmount = Math.max(...this.feeList.map((item: any) => item.toAmount));
        this.maximumFeeAmount = maxFeeAmount > 0 ? maxFeeAmount : 100;
        this.tempFeeMaxValue = this.maximumFeeAmount;
      }
      
      if(this.settlementCycle != null && this.feeList.length > 0 && this.commissionList.length > 0){
        this.dataEnable = false;
      }else{
        if(this.permissions.includes('Add')){
          this.settlementEnable = false;
        }
      }
    })
  }
  
  addCommissionRow() {
    const newRow = { fromAmount: 0, toAmount: 0, commissionType: "PERCENTAGE", commission: 0,isAmountDisabled: false };
    this.commissionList = [newRow, ...this.commissionList];
    this.gridApiCommission.setRowData(this.commissionList);
    return;
}
setCommission(){
  this.commissionList = [];
  const newRow = { fromAmount: 0, toAmount: this.maximumCommissionAmount, commissionType: "PERCENTAGE", commission: 0,isAmountDisabled: true };
  this.commissionList = [newRow, ...this.commissionList];
  return;
  
}

addFeeRow() {
  const newRow = { fromAmount: 0, toAmount: 0, commissionType: "PERCENTAGE", commission: 0,isAmountDisabled: false };
  this.feeList = [newRow, ...this.feeList];
  this.gridApiFee.setRowData(this.feeList);
  return;
}

setFee(){
this.feeList = [];
const newRow = { fromAmount: 0, toAmount: this.maximumFeeAmount, commissionType: "FLAT", commission: 0,isAmountDisabled: true };
this.feeList = [newRow, ...this.feeList];
return;

}

onGridReadyCommission(params: GridReadyEvent<any>) {
    this.gridApiCommission = params.api
}

onGridReadyFee(params: GridReadyEvent<any>) {
  this.gridApiFee = params.api
}

editSettlement(value:boolean){
  this.settlementEnable = value;
  if(value){
    this.settlementCycle = this.saveData.settlementCycle;
  }
}

editCommission(value:boolean){
  this.commissionEnable = value;
  if(value){
    this.commissionList = JSON.parse(JSON.stringify(this.saveData.commission));
  }
}

editResellerCommission(value:boolean){
  this.resellerCommissionEnable = value;
  // Cancel → reset value
    this.commissionPercentage = Number(
      this.resellerMerchantCommissionTempList?.[0]?.commission ?? 0
    );

}

editFee(value:boolean){
  this.feeEnable = value;
  if(value){
    this.feeList = JSON.parse(JSON.stringify(this.saveData.fee));
  }
}

disableAll(){
  this.settlementEnable = true;
  this.commissionEnable = true;
  this.feeEnable = true;
  this.dataEnable = true;
  this.resellerCommissionEnable= true
}

// Max value management methods
editCommissionMaxValue() {
  this.editingCommissionMaxValue = true;
  this.tempCommissionMaxValue = this.maximumCommissionAmount;
}

onCommissionMaxValueChange(event: any) {
  this.tempCommissionMaxValue = +event.target.value;
}

cancelCommissionMaxValue() {
  this.editingCommissionMaxValue = false;
  this.tempCommissionMaxValue = this.maximumCommissionAmount;
}

applyCommissionMaxValue() {
  if (this.tempCommissionMaxValue <= 0) {
    this.alertService.toastWarringMessageAlertWithMessage("Max value must be greater than 0");
    return;
  }
  
  this.merchantService.updateMaxValue(this.merchantId, Number(this.tempCommissionMaxValue), 'Merchant Fee').subscribe((response: any) => {
    if (response.response && response.response.status === 200) {
      this.maximumCommissionAmount = this.tempCommissionMaxValue;
      this.editingCommissionMaxValue = false;
      Swal.fire('Commission Max Value Updated Successfully', '', 'success');
      this.getConfirguration(); // Refresh configuration
    } else {
      Swal.fire(response.response?.message || 'Failed to update max value', '', 'error');
    }
  }, (error) => {
    Swal.fire('Error updating max value', '', 'error');
  });
}

editFeeMaxValue() {
  this.editingFeeMaxValue = true;
  this.tempFeeMaxValue = this.maximumFeeAmount;
}

onFeeMaxValueChange(event: any) {
  this.tempFeeMaxValue = +event.target.value;
}

cancelFeeMaxValue() {
  this.editingFeeMaxValue = false;
  this.tempFeeMaxValue = this.maximumFeeAmount;
}

applyFeeMaxValue() {
  if (this.tempFeeMaxValue <= 0) {
    this.alertService.toastWarringMessageAlertWithMessage("Max value must be greater than 0");
    return;
  }
  
  this.merchantService.updateMaxValue(this.merchantId, Number(this.tempFeeMaxValue), 'Additional Fee').subscribe((response: any) => {
    if (response.response && response.response.status === 200) {
      this.maximumFeeAmount = this.tempFeeMaxValue;
      this.editingFeeMaxValue = false;
      Swal.fire('Additional Fee Max Value Updated Successfully', '', 'success');
      this.getConfirguration(); // Refresh configuration
    } else {
      Swal.fire(response.response?.message || 'Failed to update max value', '', 'error');
    }
  }, (error) => {
    Swal.fire('Error updating max value', '', 'error');
  });
}

// Reset functionality
resetCommissionTable() {
  Swal.fire({
    title: 'Are you sure?',
    text: 'This will reset the commission table to default values in the database',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, reset it!'
  }).then((result) => {
    if (result.isConfirmed) {
      this.merchantService.resetConfiguration(this.merchantId, 'Merchant Fee', 'MERCHANT').subscribe((response: any) => {
        if (response.response && response.response.status === 200) {
          Swal.fire('Reset!', response.response.message || 'Commission table has been reset successfully.', 'success');
          this.getConfirguration(); // Refresh configuration from API
        } else {
          Swal.fire('Error!', response.response?.message || 'Failed to reset commission table.', 'error');
        }
      }, (error) => {
        Swal.fire('Error!', 'Failed to reset commission table.', 'error');
      });
    }
  });
}

resetFeeTable() {
  Swal.fire({
    title: 'Are you sure?',
    text: 'This will reset the fee table to default values in the database',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, reset it!'
  }).then((result) => {
    if (result.isConfirmed) {
      this.merchantService.resetConfiguration(this.merchantId, 'Additional Fee', 'MERCHANT').subscribe((response: any) => {
        if (response.response && response.response.status === 200) {
          Swal.fire('Reset!', response.response.message || 'Fee table has been reset successfully.', 'success');
          this.getConfirguration(); // Refresh configuration from API
        } else {
          Swal.fire('Error!', response.response?.message || 'Failed to reset fee table.', 'error');
        }
      }, (error) => {
        Swal.fire('Error!', 'Failed to reset fee table.', 'error');
      });
    }
  });
}

}
